import React from "react";

const GradientBackground: React.FC = () => (
  <div className="fixed left-0 top-0 z-[-2] h-full w-full bg-gradient-to-t from-white to-gray dark:hidden dark:bg-none" />
);

export default GradientBackground;
